/**
 * Shopify dynamic age gate (16+ or 18+)
 * Expects: <div id="age-gate-root" data-age-gate="true" data-min-age="16"></div>
 */
(function () {
  'use strict';

  var ROOT_ID = 'age-gate-root';
  var STYLE_ID = 'age-gate-styles';

  function sessionIsApproved(minimumAge) {
    try {
      if (window.sessionStorage.getItem('shopify_age' + minimumAge + '_confirmed') === 'true') {
        return true;
      }

      // An 18+ confirmation also satisfies a later 16+ gate in the same session.
      return minimumAge === '16' &&
        window.sessionStorage.getItem('shopify_age18_confirmed') === 'true';
    } catch (error) {
      return false;
    }
  }

  function saveApproval(storageKey) {
    try {
      window.sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
      // If storage is blocked, the gate simply reappears on the next page load.
    }
  }

  function redirectAfterRejection() {
    var referrer = document.referrer;

    if (referrer) {
      try {
        var previousUrl = new URL(referrer);
        var currentUrl = new URL(window.location.href);
        if (previousUrl.origin === currentUrl.origin && previousUrl.href !== currentUrl.href) {
          window.location.assign(previousUrl.href);
          return;
        }
      } catch (error) {
        // Fall through to the shop homepage.
      }
    }

    window.location.assign(
      window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
    );
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'body.age-gate-open{overflow:hidden!important;}',
      '.age-gate{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(15,23,42,.76);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);}',
      '.age-gate__dialog{box-sizing:border-box;width:min(100%,520px);padding:32px;border:calc(var(--popup-border-width,1)*1px) solid rgba(var(--color-foreground,18,18,18),var(--popup-border-opacity,.1));border-radius:calc(var(--popup-corner-radius,0)*1px);background:rgb(var(--color-background,255,255,255));color:rgb(var(--color-foreground,18,18,18));text-align:center;box-shadow:var(--popup-shadow-horizontal-offset,0) var(--popup-shadow-vertical-offset,10px) var(--popup-shadow-blur-radius,35px) rgba(var(--color-shadow,18,18,18),var(--popup-shadow-opacity,.25));font-family:var(--font-body-family,inherit);}',
      '.age-gate__badge{display:inline-flex;align-items:center;justify-content:center;width:64px;height:64px;margin:0 auto 18px;border:3px solid currentColor;border-radius:50%;color:rgb(var(--color-foreground,18,18,18));font-size:24px;font-weight:700;line-height:1;}',
      '.age-gate__title{margin:0 0 12px;color:inherit;}',
      '.age-gate__text{margin:0 auto 24px;max-width:44ch;color:rgba(var(--color-foreground,18,18,18),.75);font-size:1.6rem;line-height:1.5;}',
      '.age-gate__actions{display:grid;gap:12px;}',
      '.age-gate__button{width:100%;min-height:48px;}',
      '@media (max-width:480px){.age-gate__dialog{padding:26px 20px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function initAgeGate() {
    var root = document.getElementById(ROOT_ID);
    if (!root || root.getAttribute('data-age-gate') !== 'true') return;

    var requestedAge = root.getAttribute('data-min-age');
    var minimumAge = requestedAge === '16' ? '16' : '18';
    var storageKey = 'shopify_age' + minimumAge + '_confirmed';

    if (sessionIsApproved(minimumAge)) return;

    addStyles();
    root.innerHTML = [
      '<div class="age-gate" role="dialog" aria-modal="true" aria-labelledby="age-gate-title" aria-describedby="age-gate-description">',
      '  <div class="age-gate__dialog color-background-1 gradient">',
      '    <div class="age-gate__badge" aria-hidden="true">' + minimumAge + '+</div>',
      '    <h2 class="age-gate__title h1" id="age-gate-title">Altersbestätigung</h2>',
      '    <p class="age-gate__text" id="age-gate-description">Das Angebot unseres Onlineshops beinhaltet auch alkoholische Produkte (ab ' + minimumAge + ' Jahren). Um fortzufahren, bestätigst du bitte, dass du mindestens ' + minimumAge + ' Jahre alt bist.</p>',
      '    <div class="age-gate__actions">',
      '      <button class="age-gate__button button button--primary" type="button" data-age-gate-yes>Ja, ich bin mindestens ' + minimumAge + ' Jahre alt</button>',
      '      <button class="age-gate__button button button--secondary" type="button" data-age-gate-no>Nein</button>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');

    var overlay = root.querySelector('.age-gate');
    var yesButton = root.querySelector('[data-age-gate-yes]');
    var noButton = root.querySelector('[data-age-gate-no]');
    var previouslyFocused = document.activeElement;

    document.body.classList.add('age-gate-open');
    yesButton.focus();

    overlay.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === yesButton) {
        event.preventDefault();
        noButton.focus();
      } else if (!event.shiftKey && document.activeElement === noButton) {
        event.preventDefault();
        yesButton.focus();
      }
    });

    yesButton.addEventListener('click', function () {
      saveApproval(storageKey);
      document.body.classList.remove('age-gate-open');
      root.innerHTML = '';
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    });

    noButton.addEventListener('click', function () {
      noButton.disabled = true;
      yesButton.disabled = true;
      redirectAfterRejection();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeGate, { once: true });
  } else {
    initAgeGate();
  }
})();
